import type { ReactNode } from "react";
import { cn } from "@repo/utils";

/**
 * En-tête de page : titre, sous-titre, et zone d'actions à droite.
 *
 * Existe pour que le `text-3xl font-bold` ne soit plus recopié dans chaque
 * route : au rebrand, l'échelle typographique change ici et nulle part ailleurs.
 * Les valeurs reprises sont exactement celles rendues aujourd'hui.
 */
export function PageTitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <h1 className={cn("text-3xl font-bold", className)}>{children}</h1>;
}

export function PageSubtitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p className={cn("text-muted-foreground mt-1", className)}>{children}</p>
  );
}

export function PageHeader({
  titre,
  sousTitre,
  actions,
  className,
}: {
  titre: ReactNode;
  sousTitre?: ReactNode;
  /** Boutons alignés à droite du titre. */
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mb-8 flex items-center justify-between gap-4",
        className,
      )}
    >
      <div className="min-w-0">
        <PageTitle>{titre}</PageTitle>
        {sousTitre ? <PageSubtitle>{sousTitre}</PageSubtitle> : null}
      </div>
      {actions ? (
        <div className="flex shrink-0 items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
